import React, { type FC, useState } from 'react';

import cn from 'classnames';

import type { TabsProps } from './types';

import styles from './styles.module.scss';

export const Tabs: FC<TabsProps> = ({ tabs }) => {
	const [activeIndex, setActiveIndex] = useState(0);

	return (
		<div className={styles.TabsWrapper}>
			<div className={styles.TabsContainer}>
				{tabs.map((tab, index) => (
					<div
						key={tab.label}
						className={cn(styles.TabLabel, { [styles.active]: activeIndex === index })}
						onClick={() => setActiveIndex(index)}
					>
						{tab.label}
					</div>
				))}
			</div>
			<div className={styles.TabsContent}>{tabs[activeIndex].content}</div>
		</div>
	);
};
